import React from 'react';
import { useQuery } from '@apollo/client';
import { FeatureTopic, FeatureTopics as FeatureTopicsType } from '~/generated';
import { listFeatureTopics } from '~/queries/featureTopic';
import {
  Box,
  Skeleton,
  Stack,
  VStack,
  Heading,
  Text,
  Button,
  Link,
} from '@chakra-ui/react';
import { ArrowRightIcon } from '@chakra-ui/icons';

const FeatureTopics = () => {
  const { data } = useQuery<{
    featureTopics: FeatureTopicsType;
  }>(listFeatureTopics);

  const topics = data?.featureTopics.data;
  if (topics === undefined) {
    return (
      <Stack>
        <Skeleton height="20px" />
        <Skeleton height="20px" />
        <Skeleton height="20px" />
      </Stack>
    );
  }

  return (
    <Box maxW="1020px" sx={{ mx: 'auto' }}>
      <VStack
        sx={{ width: '100%', display: 'flex' }}
        spacing={{ base: 0, md: 1 }}
        fontSize={{ base: '80%', md: 'inherit' }}
      >
        <Heading size="lg" my={{ base: 5, md: 5 }} sx={{ color: 'white' }}>
          募集特集
        </Heading>

        <Stack
          direction={{ base: 'column', md: 'row' }}
          w={{ base: '90%', md: '100%' }}
          alignItems={{ base: 'center', md: 'initial' }}
          spacing={5}
        >
          {topics.map((topic: FeatureTopic) => (
            <Box
              w={{ base: '100%', md: '100x' }}
              boxShadow={{ base: 'none', md: 'xl' }}
              sx={{
                border: '1px solid #E8E8E8',
                flexGrow: 1,
                boxSizing: 'border-box',
                display: 'flex',
                bgColor: 'white',
                borderRadius: '20px',
              }}
              key={topic.id}
            >
              <Box
                sx={{
                  flexGrow: 1,
                  p: 4,
                  textAlign: 'left',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Heading
                  size="md"
                  sx={{
                    wordBreak: 'break-word',
                    my: 3,
                    minHeight: '40px',
                    borderBottom: '1px solid #000d1f',
                  }}
                >
                  {topic.title}
                </Heading>
                <Text>{topic.description}</Text>
                <Link
                  href={`/topics/${topic.slug}`}
                  sx={{ flexGrow: 1, display: 'flex', alignItems: 'end' }}
                >
                  <Button
                    sx={{
                      borderRadius: '20px',
                      mt: '20px',
                      // 背景色と文字色はサインアップボタンの画像と同じ色を仕様
                      bgColor: '#cf1459',
                      color: '#ffe12d',
                      w: '100%',
                    }}
                    _hover={{
                      opacity: 0.6,
                      cursor: 'pointer',
                    }}
                  >
                    求人はこちらから
                    <ArrowRightIcon
                      sx={{ pl: '10px', color: '#ffe12d', width: 'unset' }}
                    />
                  </Button>
                </Link>
              </Box>
            </Box>
          ))}
        </Stack>
      </VStack>
    </Box>
  );
};

export default FeatureTopics;
